<template>
  <v-dialog v-model="showModal" max-width="500" dark>

    <!-- Modal Card -->
    <v-card>
      <v-card-title class="headline">
        <v-icon color="warning">warning</v-icon>
        <p>
          {{$t('titles.sendAnalyzes')}} 
        </p>
      </v-card-title>
      <v-card-text>
        <ul>
          <div v-for="image in images" :key="image.uuid">
            <li v-if="image.checked === true" class="mb-2">
              <span v-html="$t('texts.analyzeAOIName', {aoiName: image.aoiName})"></span> <br>
              <span v-html="$t('texts.analyzeImgName', {imgName: image.name.split('.')[0]})"></span> <br>
              <span v-html="$t('texts.analyzeSelections', {nbrSelections: image.canvasList.length})"></span>
            </li>
          </div>
        </ul>
      </v-card-text>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="showModal = false">{{$t('buttons.cancel')}}</v-btn>
        <v-btn color="primary" flat @click="exportSelection">{{$t('buttons.analyzeAll')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    images: Array,
    modalAOI: Boolean
  },
  data() {
    return {
      showModal: false
    };
  },
  watch: {
    modalAOI(value) {
      this.showModal = value;
    },
    showModal(value) {
      if (value === false)
        this.$emit('close-modal');
    }
  },
  methods: {
    exportSelection() {
      this.images.forEach(async (image) => {
        if (image.checked === false) return
        let allAOI = image.canvasList.map((shape, index) => {
          let scaleImg =  image.width / shape.width;
          let name, type, label;
          if (shape.type === 'rectangle') {
            type = 'box';
            let BR, TL;
            // Bottom Right, filtrer x max et y max.
            let xMax = 0, yMax = 0, xMin = 5000, yMin = 5000;

            shape.positions.forEach((pos) => {
              if (pos.start[0] > xMax)
                xMax = pos.start[0];
              else if (pos.start[0] < xMin)
                xMin = pos.start[0];
              if (yMax < pos.start[1])
                yMax = pos.start[1];
              else if (yMin > pos.start[1])
                yMin = pos.start[1];
            });
            BR = {
              x: parseInt(xMax * scaleImg),
              y: parseInt(yMax * scaleImg)
            };
            TL = {
              x: parseInt(xMin * scaleImg),
              y: parseInt(yMin * scaleImg)
            };
            name = shape.id;
            label = shape.label;
            return {BR, TL, name, type, label, index}
          } else if (shape.type === 'circle') {
            type = 'circle';
            name = shape.id;
            label = shape.label;
            let [x1, y1] = Object.values(shape.positions[0].start);
            let [x2, y2] = Object.values(shape.positions[0].end);
            let x = Math.abs(x1 - x2);
            let y = Math.abs(y1 - y2);
            let RADIUS = parseInt(Math.sqrt(x ** 2 + y ** 2) * scaleImg);
            let CENTER = {x: parseInt(x1 * scaleImg), y: parseInt(y1 * scaleImg)};
            return {RADIUS, CENTER, name, type, label, index}
          } else if (shape.type === 'polygon') {
            type = 'polygon';
            name = shape.id;
            label = shape.label;
            let POINTS = shape.positions.map((pos) => {
              let [x, y] = pos.start;
              x = parseInt(x * scaleImg);
              y = parseInt(y * scaleImg);
              return [x, y];
            });
            return {POINTS, name, type, label, index}
          } else return {type: null};
        });
        allAOI = allAOI.filter((aoi) => (aoi.type === 'box' || aoi.type === 'circle' || aoi.type === 'polygon'));
        let aoi_json = {
          AOI: allAOI,
          media_height: image.height,
          media_name: image.name,
          media_uuid: image.uuid,
          media_width: image.width,
          number_of_AOI: image.canvasList.length,
        };
        let apiDatas = {
          name: image.aoiName,
          media: image.uuid,
          aoi_json: aoi_json
        };
        await this.$store.dispatch("AOIanalysis/post", apiDatas);
      });
      this.$store.commit('image/emptyMultiSelectImg');
      this.$router.go(-1);
      this.showModal = false;
    }
  }
};
</script>
<style lang="sass" scoped>
.v-btn:focus 
  outline: none

.headline 
  display: flex !important
  i
    flex: 1
  p
    flex: 5
    margin: 0
</style>
